// DO NOT EDIT
  // this file is generated by /internals/populate-icons script
  import * as React from 'react'
  // @ts-ignore
  import { Grid } from 'react-feather'
  import IconBase from './../../IconBase'

  function IconGrid(props: any) {
    return <IconBase icon={Grid} {...props} />
  }

  export default IconGrid
  